import {Component} from '@angular/core';
import {ResponsiveService} from '../services/responsive.service';
import {VersionService} from '../services/version.service';
import {TranslatePipe} from '@ngx-translate/core';

import {UtIconComponent} from '../ui';
import {ResponsiveContainerComponent} from '../responsive-container/responsive-container.component';

const { version } = require('../../../package.json');
const { environment } = require('src/environments/environment');

@Component({
  selector: 'app-version',
  templateUrl: './version.component.html',
  styleUrls: ['./version.component.scss'],
  imports: [TranslatePipe, UtIconComponent, ResponsiveContainerComponent],
})
export class VersionComponent {
  versionInfoVisible = false;
  frontend: string;
  backend: string;
  constructor(
    private versionService: VersionService,
    public responsive: ResponsiveService,
  ) {
    this.frontend = version;
  }

  fetchBackendVersion(): void {
    this.versionService
      .getBackendVersion()
      .then((backendVersion) => (this.backend = backendVersion));
  }

  toggleVersionInfo(): void {
    this.versionInfoVisible = !this.versionInfoVisible;
    if (this.versionInfoVisible && !this.backend) {
      this.fetchBackendVersion();
    }
  }

  get thisYear() {
    return new Date().getFullYear();
  }
}
